import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import { TIMEOUT_STORE } from 'util/constants';

module.exports = {
    ...storeModuleFactory({
        name:     'azureRefreshToken',
        endpoint: endpoints.azureRefreshToken.endpoint,
        timeout:  TIMEOUT_STORE.TIMEOUT_STORE_SMALL
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/azureRefreshToken.js